module.exports = __webpack_public_path__ + "img/asset2x1.2163ad5d.png";